// Configuración para el asistente Voiceflow
export const VOICEFLOW_CONFIG = {
  // ID del proyecto Voiceflow
  projectID: '6a6c256f24725b058d7d7ece',
  // ID de la versión del proyecto (por ejemplo, 'production')
  versionID: 'production',
  // API Key para autenticación con Voiceflow
  apiKey: 'VF.DM.6a6c25a843f4384457ca3cec.hKN8pVqccFiOC5Rw',
  widget: {
    // Título que se muestra en el widget del chat
    title: 'Terapia Online',
    // Subtítulo del asistente virtual
    subtitle: 'Asistente Virtual',
    // Color primario del widget (usado en botones, encabezados, etc.)
    primaryColor: '#3B82F6',
    // Color de fondo del widget
    backgroundColor: '#FFFFFF',
    avatar: {
      // URL de la imagen del avatar del asistente
      src: 'https://via.placeholder.com/40x40/3B82F6/FFFFFF?text=LE',
      // Texto alternativo para la imagen del avatar
      alt: 'Asistente Virtual'
    },
    launcher: {
      // Oculta el botón de lanzamiento del chat, ya que se usa dentro de un iframe
      hidden: true // Siempre oculto ya que usamos iframe
    },
    chat: {
      // Sin welcomeMessage global: cada sala de Voiceflow gestiona su propio saludo
      welcomeMessage: '',
      // Texto de marcador de posición en el campo de entrada de mensajes
      inputPlaceholder: 'Escribe tu mensaje...',
      audio: {
        // Habilita la funcionalidad de audio en el chat
        enabled: true,
        // Indica si el audio debe reproducirse automáticamente
        autoplay: false
      }
    }
  }
};